export default class OnsiteLandingPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.createLoading();
    this.checkSrc();
  }

  createLoading() {
    this.loadingDOM = document.createElement("div");
    this.loadingDOM.id = "onsite-loading";

    const loadingWrapperDOM = document.createElement("div");
    loadingWrapperDOM.className = "loading-wrapper";
    this.loadingDOM.append(loadingWrapperDOM);

    const loaderDOM = document.createElement("div");
    loaderDOM.className = "loader";
    loadingWrapperDOM.append(loaderDOM);

    this.dom.append(this.loadingDOM);
  }

  async checkSrc() {
    const previewDOM = this.dom.querySelector(".preview-item");
    let expID = previewDOM.getAttribute("data-experience");
    const API = `https://fabrix.hk/?www_api=1&cmd=issetExperienceMedia&experience=${expID}`;
    //const API = `https://fabrix.pmq.org.hk/shop/?www_api=1&cmd=issetExperienceMedia&experience=${expID}`;
    // const API = window.location.origin+`?www_api=1&cmd=issetExperienceMedia&experience=${expID}`;
    // console.log(API);
    const response = await fetch(API);
    const result = await response.json();
    console.log(result);

    if (result.video_url != null) {
      // const videoDOM = document.createElement("video");
      // videoDOM.setAttribute("muted", "");
      // videoDOM.setAttribute("autoplay", "");
      // videoDOM.setAttribute("playsinline", "");
      // videoDOM.setAttribute("loop", "");
      // videoDOM = previewDOM.querySelector('video')
      // const sourceDOM = document.createElement("source");
      // sourceDOM.setAttribute("src", result.video_url);
      // sourceDOM.setAttribute("type", "video/mp4");
      // videoDOM.append(sourceDOM);
      // previewDOM.append(videoDOM);

      let videoDOM = previewDOM.querySelector('video')
      let xhr = new XMLHttpRequest();
      xhr.open('GET', result.video_url)
      xhr.responseType = 'blob'
      xhr.onload = (e) => {
        // console.log(e)
        let blob = e.target.response
        // console.log(blob);
        
        let url = URL.createObjectURL(blob)
        videoDOM.src = url
        videoDOM.classList.remove('d-none')
      }
      xhr.send()
      

      this.loadingDOM.remove();
    } else if (result.image_url != null) {
      const imgDOM = document.createElement("img");
      imgDOM.setAttribute("src", result.image_url);
      previewDOM.append(imgDOM);
      this.loadingDOM.remove();
    } else {
      setTimeout(() => {
        this.checkSrc();
      }, 2000);
    }

    // const mediaSrc = media.getAttribute("src");
    // if (mediaSrc == "") {
    //   setTimeout(() => {
    //     location.reload();
    //   }, 2000);
    // } else {
    //   this.loadingDOM.remove();
    // }
  }

  resize() {}
}
